// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(min-width: 1025px)";
var _4 = "(max-width: 1024px)";
var _5 = "wrapper-29Neq";
export { _1 as "__esModule", _2 as "mobile", _3 as "laptop", _4 as "tablet", _5 as "wrapper" }
export default { "__esModule": _1, "mobile": _2, "laptop": _3, "tablet": _4, "wrapper": _5 }
